import { Component, input, model } from "@angular/core";

@Component({
    selector: "ev-seemore-button",
    templateUrl: "./seemore-button.component.html",
    styleUrls: ["./seemore-button.component.scss"],
})
export class SeeMoreButtonComponent {
  maxItems = input.required<number>();
  steps = input.required<number>();
  currentNumItems = model.required<number>();

  onSeeMoreClicked(): void {
    const next = Math.min(this.maxItems(), this.currentNumItems() + this.steps());
    this.currentNumItems.set(next);
  }
}
